/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.getSession'

export { $nsid }

/** Get information about the current auth session. Requires auth. */
const main = l.query(
  $nsid,
  l.params(),
  l.jsonPayload({
    handle: l.string({ format: 'handle' }),
    did: l.string({ format: 'did' }),
    didDoc: l.optional(l.lexMap()),
    email: l.optional(l.string()),
    emailConfirmed: l.optional(l.boolean()),
    emailAuthFactor: l.optional(l.boolean()),
    active: l.optional(l.boolean()),
    status: l.optional(
      l.string<{ knownValues: ['takendown', 'suspended', 'deactivated'] }>(),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
